export default "__VITE_ASSET__1443f0db__"